import { render } from "./ListaPaginada.vue?vue&type=template&id=57d039a2"
import script from "./ListaPaginada.vue?vue&type=script&lang=js"
export * from "./ListaPaginada.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__